export default {
  "content": "<g stroke-width=\"4\"><circle cx=\"40\" cy=\"40\" opacity=\".2\" r=\"38\" stroke=\"#aeb1b5\"/><path d=\"M78 40C78 19.013 60.987 2 40 2\" stroke=\"#ff00cb\"/></g>",
  "attrs": {
    "fill": "none",
    "height": "80",
    "viewBox": "0 0 80 80",
    "width": "80",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};